/* IMPORT */
import modalReducer from './modal/reducer';
import appReducer from './app/reducer';

export default {
    /* EXPORT */
	modal: modalReducer,
	app: appReducer,
};
